import React from 'react';
import ReactDOM from 'react-dom';
import Favicon from 'react-favicon';
import './styles/index.css';
import './styles/common-styles.css';


import Header from "./components/header";
import Main from './components/main';
import Footer from "./components/footer";
import Preloader from "./components/preloader";



class SiteView extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Favicon url='http://faviconka.ru/ico/faviconka_ru_1373.gif' />
                {/*<Preloader />*/}
                <Header />
                <Main />
                <Footer/>
            </React.Fragment>
        )
    }
}

// ========================================

ReactDOM.render(
    <SiteView />,
    document.getElementById('root')
);
